import { render, staticRenderFns } from "./zyzzc.vue?vue&type=template&id=4f5bf67c&scoped=true&"
import script from "./zyzzc.vue?vue&type=script&lang=js&"
export * from "./zyzzc.vue?vue&type=script&lang=js&"
import style0 from "./zyzzc.vue?vue&type=style&index=0&id=4f5bf67c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5bf67c",
  null
  
)

export default component.exports